import React from 'react';
import { getHistory, clearHistory } from '../utils/localStorage';

const History = ({ onSelectNumbers, refreshTrigger }) => {
  const [history, setHistory] = React.useState([]);

  React.useEffect(() => {
    loadHistory();
  }, [refreshTrigger]);

  const loadHistory = () => {
    const savedHistory = getHistory();
    setHistory(savedHistory);
  };

  const handleClear = () => {
    if (window.confirm('Möchten Sie wirklich den gesamten Verlauf löschen?')) {
      clearHistory();
      setHistory([]);
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (history.length === 0) {
    return (
      <div className="card bg-light bg-opacity-10 border-0">
        <div className="card-body text-center">
          <h5 className="card-title text-white">Verlauf</h5>
          <p className="text-white-50 mb-0">Noch keine Zahlen generiert. Generiere deine ersten Glückszahlen!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card bg-light bg-opacity-10 border-0">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title text-white mb-0">Dein Verlauf</h5>
          <button className="btn btn-sm btn-danger text-white" onClick={handleClear}>
            Verlauf löschen
          </button>
        </div>
        <div className="d-flex flex-column gap-3">
          {history.map((entry, index) => (
            <div key={index} className="card bg-dark bg-opacity-25 border border-light border-opacity-25">
              <div className="card-body">
                <div className="text-muted small mb-2">{formatDate(entry.timestamp)}</div>
                <div className="d-flex gap-2 align-items-center flex-wrap mb-2">
                  {entry.numbers.map((num, i) => (
                    <div key={i} className="history-ball">{num}</div>
                  ))}
                  <div className="history-superzahl">{entry.superzahl}</div>
                </div>
                {onSelectNumbers && (
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => onSelectNumbers(entry.numbers, entry.superzahl)}
                  >
                    Verwenden
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default History;
